// Shared app constants
export const DEFAULT_OVERLAYS_SLOT =
  "https://app.overlays.uno/control/1npufy2oEz2m9o3HHJnyrr";
